<template>
  <div class="container-fluid" style="background-color: black" :class="{ 'p-0': isMobile() }">
    <div class="row px-0" style="height: auto">
      <div v-if="!isMobile()" class="spacer-right col-xs-0 col-sm-4"></div>
      <div class="col px-0" style="box-shadow: 0 0 20px 5px rgba(255, 255, 255, 0.5)">
        <nav v-if="!touchdown" @click="toggleTouchDown()" id="openthis" class="invitation-nav opacity-9 text-center d-inline" style="cursor: pointer; z-index: 999">
          <span style="position: relative; bottom: 10px">Open The Invitation Letter</span>
        </nav>

        <!-- <nav class="invitation-nav d-none d-sm-block"></nav> -->
        <section id="welcome" class="text-center" style="background: url('/Welcome.svg'); background-size: cover; height: 100vh; background-position: center bottom">
          <h6 style="position: relative; top: 10vh; color: white">We're Getting Married!</h6>
          <h1 class="vibe mt-3" style="position: relative; top: 10vh; color: white; font-size: 3em">Vita & Ehza</h1>

          <h6 style="position: relative; top: 10vh; color: white">{{ guestData.event.day_date }}</h6>
        </section>
        <filter v-if="touchdown">
          <section id="about" style="background: url('/About.svg'); background-size: cover; background-position: center">
            <div class="row text-center">
              <div class="col w-50 mt-2 d-flex justify-content-center">
                <div class="w-50 mt-4" style="min-width: 300px">
                  <h5>Dear, {{ guestData.full_name }}</h5>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="col w-50 d-flex justify-content-center">
                <div class="w-50 text-sm" style="font-size: 0.8em">We sincerelly hope that you will be able to attend this ceremony and celebrate with our family and friends.</div>
              </div>
            </div>

            <div class="row" style="height: 50%; position: relative; top: -130px">
              <div class="col">
                <span class="story bride">
                  <img class="photo" style="float: left" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.bride_image" />
                  <img class="photo" style="float: left; position: relative; top: 240px; left: -80px" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.bride_image" />
                </span>
                <span id="brideintro" class="text-center">
                  <h5 id="bridename" class="vibe">Vita Deville</h5>
                  <p>The fourth daughter of Mr. Deville and Mrs. Jemima</p>
                </span>
              </div>
            </div>
            <div class="row" style="height: 50%; position: relative; top: -130px">
              <div class="col story groom">
                <span class="story groom">
                  <img class="photo" style="float: right" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.groom_image" />
                  <img class="photo" style="float: right; position: relative; top: 25px; right: -80px" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.groom_image" />
                </span>
                <div id="groomintro">
                  <h5 id="groomname" class="vibe">Ehza Kerez</h5>
                  <p>The first son of Mr. Zaki Kerez and Mrs. Olivia</p>
                </div>
              </div>
            </div>
            <!-- <span class="story bride">
            <img class="photo" style="float: left;" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.bride_image" />
            <img class="photo" style="float: left; position: relative; top: 230px; left: -80px;" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.bride_image" />
            <span></span>
          </span>
          <span class="story groom">
            <img class="photo" style="float: right;" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.groom_image" />
            <img class="photo" style="float: right; position: relative; top: 180px; right: 50px;" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + this.guestData.event.groom_image" />
          </span> -->
            <!-- <img id="decor1" src="/flower1.svg" /> -->
          </section>
          <section id="story">
            <div class="pt-5 px-2" style="width: 100%; position: relative; right: -15px; top: 0px; text-align: center">
              <h3>Our Love Story</h3>
              <span v-for="(story, index) in this.storyData" class="row w-100 storycard">
                <div class="col">
                  <h4 style="position: relative; left: -35px; top: 20px">{{ story.title }}</h4>
                  <h5 style="position: relative; left: -35px; top: 20px">{{ getStoryDate(story.story_date) }}</h5>
                  <img class="mt-4 storythumb" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + story.gallery.image" />
                  <span class="mx-3 mt-3 storydesc" style="float: right; text-align: left; width: 70%">
                    {{ story.description }}
                  </span>
                </div>
              </span>
            </div>
          </section>
          <section class="pt-3" id="gallery">
            <div id="fullImg"></div>
            <div style="width: 50%; position: relative; left: 120px; top: 150px; text-align: center">
              <h3>Gallery</h3>
            </div>
            <img id="decor2" src="/flower2.svg" />
            <div class="row w-100" style="position: relative; right: -12px; top: 100px">
              <img @click="showFullImg(src)" class="col galleryPhoto" v-for="(file, index) in this.galleryData" :src="'https://d20na0ry3pyp1s.cloudfront.net/' + file.image" />
              <!-- <div class="col galleryPhoto">a</div> -->
            </div>
            <img id="decor3" src="/flower2.svg" />
          </section>
          <section id="event" style="">
            <div style="width: 50%; position: relative; left: 120px; top: -125px; text-align: center">
              <h3>Event Details</h3>
            </div>
            <div class="row" style="height: 250px; position: relative; top: -100px">
              <div class="col px-0 bg-white mx-5" style="position: relative; border-radius: 6px; height: 220px">
                <div class="text-center pt-3 pb-1 font-weight-bold" style="font-size: 0.8em"><h5>Save The Date</h5></div>
                <div class="text-center">
                  <span style="font-size: 0.8em">{{ this.guestData.event.day_date }}</span>
                </div>
                <div class="pt-3" id="countdown">
                  <ul>
                    <li>
                      <span id="days"></span>
                    </li>

                    <li>
                      <span id="hours"></span>
                    </li>
                    <li>
                      <span id="minutes"></span>
                    </li>
                    <li>
                      <span id="seconds"></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center">
              <div class="col px-0 mt-4 bg-white mx-5" style="position: relative; bottom: 100px; border-radius: 6px; min-height: 450px">
                <div class="text-center pt-3 pb-1 font-weight-bold"><h5>Venue</h5></div>
                <div class="text-center px-4 pt-2"><span class="venue">Jl. Pegangasaan Utama, No. 17 Jakarta Barat, Jakarta </span></div>
                <div class="pt-3 row" id="maps">
                  <div class="col">
                    <div class="mapouter d-flex justify-content-center">
                      <div class="gmap_canvas"><iframe width="380" height="220" id="gmap_canvas" loading="lazy" v-bind:src="getEventLoc()" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div>
                    </div>
                  </div>
                </div>
                <div class="pt-3 row" id="map">
                  <div class="col d-flex justify-content-center text-center">
                    <div class="mx-3" style="width: 200px; border: solid 2px rgba(0, 0, 0, 0.5); border-radius: 6px; width: 100%; line-height: 55px">See Location</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center">
              <div class="col px-0 mt-4 bg-white mx-5" style="position: relative; bottom: 75px; border-radius: 6px; height: 850px; max-width: 75vw">
                <div class="pt-3 row" id="qr">
                  <div class="col d-flex justify-content-center">
                    <QRCodeVue3
                      class="p-5"
                      :width="200"
                      :height="200"
                      :value="guestAttendanceAPI"
                      :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                      :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
                      :dotsOptions="{
                        type: 'square',
                        color: '#000000',
                      }"
                      :backgroundOptions="{ color: '#ffffff' }"
                      :cornersSquareOptions="{ type: 'square', color: '#000000' }"
                      :cornersDotOptions="{ type: 'square', color: '#000000' }"
                      fileExt="png"
                      myclass="my-qur"
                      imgclass="img-qr"
                      :downloadOptions="{ name: 'vqr', extension: 'png' }"
                    />
                  </div>
                </div>
                <div class="text-center pt-3 pb-1 font-weight-bold">
                  <span style="font-size: 24px"
                    >{{ guestData.full_name }}, <br />
                    Would you be there?</span
                  >
                </div>
                <div class="text-center px-4 pt-2"><span style="font-size: 16px">We sincerelly hope that you will be able to attend this ceremony and celebrate with our family and friends.</span></div>
                <div class="pt-3 row" id="rsvp">
                  <div class="col d-flex justify-content-center text-center">
                    <select class="mx-3 py-3" style="width: 200px; border: solid 2px rgba(0, 0, 0, 0.5); border-radius: 6px; width: 100%; line-height: 55px">
                      <option>Presence</option>
                      <option>Yes</option>

                      <option>No</option>
                    </select>
                  </div>
                </div>
                <div class="pt-3 row" id="rsvp">
                  <div class="col d-flex justify-content-center text-center">
                    <select class="mx-3 py-3" style="width: 200px; border: solid 2px rgba(0, 0, 0, 0.5); border-radius: 6px; width: 100%; line-height: 55px">
                      <option>Pax</option>
                      <option>1</option>
                      <option>2</option>
                      <option>3</option>
                      <option>4</option>
                      <option>5</option>
                      <option>6</option>
                    </select>
                  </div>
                </div>
                <div class="pt-3 row" id="rsvp">
                  <div class="col d-flex justify-content-center text-center">
                    <input type="button" value="Submit" class="mx-3 py-3 bg-secondary text-white font-weight-bold" style="width: 200px; border: solid 2px rgba(0, 0, 0, 0.5); border-radius: 6px; width: 100%; line-height: 22px" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="more">
            <div class="row">
              <div class="col px-0 mx-3 bg-white" style="position: relative; bottom: -75px; height: 220px">
                <div class="row">
                  <div class="col">
                    <div class="text-center pt-3 pb-1 font-weight-bold"><h5>Send a Gift</h5></div>
                    <div class="pt-1 px-4 pb-1 font-weight-bold"><h5>Bank</h5></div>
                  </div>
                </div>
                <div class="row mx-1" style="position: relative; height: 300px">
                  <div class="col">
                    <div class="pt-5" id="cards">
                      <div class="card-group bg-bni" style="border-radius: 30px">
                        <div class="card">
                          <div class="logo"><img src="/banks/BNI.svg" alt="Visa" /></div>
                          <div class="chip"><img src="https://raw.githubusercontent.com/dasShounak/freeUseImages/main/chip.png" alt="chip" /><span id="card0" @click="copyToClipboard(0)" class="ni ni-ungroup m-4"> </span></div>
                          <div id="cardNumber0" class="number">1234 5678 9012 3456</div>
                          <div class="name">SHOUNAK DAS</div>
                          <div class="from">10/19</div>
                          <div class="to">06/21</div>
                          <div class="ring"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mx-1" style="position: relative; height: 300px">
                  <div class="col">
                    <div class="pt-5" id="cards">
                      <div class="card-group bg-mandiri" style="border-radius: 30px">
                        <div class="card">
                          <div class="logo"><img src="/banks/MANDIRI.svg" alt="Visa" /></div>
                          <div class="chip"><img src="https://raw.githubusercontent.com/dasShounak/freeUseImages/main/chip.png" alt="chip" /><span id="card1" @click="copyToClipboard(1)" class="ni ni-ungroup m-4"> </span></div>
                          <div id="cardNumber1" class="number">1234 5678 9012 3456</div>
                          <div class="name">SHOUNAK DAS</div>
                          <div class="from">10/19</div>
                          <div class="to">06/21</div>
                          <div class="ring"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mx-1" style="position: relative; height: 300px">
                  <div class="col">
                    <div class="pt-5" id="cards">
                      <div class="card-group bg-bca" style="border-radius: 30px">
                        <div class="card">
                          <div class="logo"><img src="/banks/BCA.svg" alt="Visa" /></div>
                          <div class="chip"><img src="https://raw.githubusercontent.com/dasShounak/freeUseImages/main/chip.png" alt="chip" /><span id="card2" @click="copyToClipboard(2)" class="ni ni-ungroup m-4"> </span></div>
                          <div id="cardNumber2" class="number text-white">1234 5678 9012 3456</div>
                          <div class="name text-white">SHOUNAK DAS</div>
                          <div class="from text-white">10/19</div>
                          <div class="to text-white">06/21</div>
                          <div class="ring"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col px-0mx-3" style="position: relative; bottom: -50px; border-radius: 6px; height: 220px">
                    <div class="row">
                      <img src="/hp.svg" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col px-0 bg-white mx-3" style="position: relative; bottom: -450px; border-radius: 6px; height: 250px">
                    <div class="mx-3 pt-3 pb-1 font-weight-bold"><h5>Send Wishes</h5></div>

                    <div class="row">
                      <div class="col">
                        <textarea class="mx-3" placeholder="Wishing you fulfillment of every dream!" rows="4" />
                        <div class="col d-flex justify-content-center text-center">
                          <input type="button" value="send" class="mx-3 mt-2 py-3 bg-secondary text-white font-weight-bold" style="width: 200px; border: solid 2px rgba(0, 0, 0, 0.5); border-radius: 6px; width: 15%; line-height: 14px; position: absolute; bottom: 10; left: 0" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div id="comments" class="col px-0 bg-white mx-3" style="position: relative; bottom: -450px; height: 250px; overflow-y: scroll">
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                    <div class="row m-2">
                      <div class="col">
                        <h5 class="text-sm"><span style="float: left">Khoer Ujang</span><span style="float: right; opacity: 0.5">20 Minutes Ago</span></h5>
                      </div>
                      <div class="row my-2">
                        <div class="col">
                          <div class="text-sm" style="font-size: 22px"><span style="float: left">So Happy to celebrate this day with you both!</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col px-0 mx-2" style="position: relative; bottom: -480px; border-radius: 6px; height: 220px">
                    <div class="row">
                      <img src="/footer.jpg" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col bg-white px-1 mx-0" style="position: absolute; bottom: -2490px; left: -0px; width: 700px">
                    <div>
                      <span style="float: left; line-height: 42px; padding-left: 30px">
                        <img src="/mavent_logotype.svg" style="transform: scale(1.5)" />
                      </span>

                      <span style="float: right; line-height: 42px; padding-right: 20px; font-size: 12px">
                        <a href="#" class="text-secondary"> Privacy and Terms </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </filter>
      </div>
      <div v-if="!isMobile()" class="spacer-left col-4 col-xs-0"></div>
    </div>
  </div>
</template>

<script>
  import QRCodeVue3 from "qrcode-vue3";
  import moment from "moment";
  import $ from "jquery";
  import axios from "axios";
  import "bootstrap/dist/css/bootstrap.min.css";
  import "bootstrap";

  export default {
    name: "invitation",
    data() {
      return {
        countdown: "",
        touchdown: true,
        eventloc: "Jakarta International Stadium",
        showMenu: false,
        iconUrl: require("../../public/mavent.svg"),
        guestAttendance: "https://api.macra.co.id/mavent/guest/details/" + this.$route.params.id,
        guestData: "",
        galleryData: "",
        storyData: "",
        windowWidth: window.innerWidth,
      };
    },
    components: {
      QRCodeVue3,
      moment,
    },
    mounted() {},
    computed: {
      isTouchDown() {
        return this.touchdown;
      },
      showcover() {
        return this.showMenu;
      },
      countdownTimer() {
        return moment("2022-10-10T12:00:00.000Z") | moment("subtract", "16/09/2022");
      },
      guestAttendanceAPI() {
        return this.guestAttendance;
      },
    },
    methods: {
      getEventLoc() {
        let api = "https://www.google.com/maps/embed/v1/place?key=AIzaSyCVIpGwa9fuiz8eojeMTBBb-OIEG-VkbnI&q=";
        let loc = this.eventloc.split(" ").join("+");
        return api.concat(loc);
      },

      copyToClipboard(i) {
        // Get the text field
        var r = document.createRange();
        r.selectNode(document.getElementById("cardNumber" + i));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        $("#card" + i).html(" Copied to clipboard");
        setTimeout(() => {
          $("#card" + i).html("");
        }, 1000);
      },

      getStoryDate(date) {
        moment(date).format("MM/DD/YYYY");
      },

      toggleTouchDown() {
        this.touchdown = true;
        setTimeout(() => {
          $("html, body").animate(
            {
              scrollTop: $("#about").offset().top,
            },
            1000
          );
        }, 500);
      },

      isMobile() {
        // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //   return true;
        // } else {
        //   return false;
        // }

        if (this.windowWidth < 360) {
          return true;
        } else {
          return false;
        }
      },
    },

    beforeMount() {
      let map;

      function initMap() {
        map = new google.maps.Map(document.getElementById("map"), {
          center: { lat: -34.397, lng: 150.644 },
          zoom: 8,
        });
      }

      window.initMap = initMap;
    },
    beforeUnmount() {},
    created() {
      function getTimeRemaining(endtime) {
        var t = Date.parse(endtime) - Date.parse(new Date());
        if (t < 0) {
          return false;
        }
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          total: t,
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds,
        };
      }
      function initializeClock(id, endtime) {
        var clock = document.getElementById(id);
        var daysSpan = $("#days");
        var hoursSpan = $("#hours");
        var minutesSpan = $("#minutes");
        var secondsSpan = $("#seconds");
        function updateClock() {
          var t = getTimeRemaining(endtime);
          if (t) {
            $("#days").html(t.days + "<br /> Days");
            $("#hours").html(("0" + t.hours).slice(-2) + "<br /> Hours");
            $("#minutes").html(("0" + t.minutes).slice(-2) + "<br /> Minutes");
            $("#seconds").html(("0" + t.seconds).slice(-2) + "<br /> Seconds");
          } else {
            clearInterval(timeinterval);
          }
        }

        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
      }

      //   Guest Details
      axios
        .get("https://api.macra.co.id/mavent/guest/details/" + this.$route.params.id)
        .then((response) => {
          this.guestData = response.data.guestData;
        })
        .catch((error) => {
          console.log(error.message);
        });

      setTimeout(() => {
        var deadline = new Date(); //today
        deadline.setDate(deadline.getDate() + 7);
        initializeClock("countdown", this.guestData.event.event_date);
      }, 1000);

      //   Event Gallery
      axios
        .get("https://api.macra.co.id/mavent/gallery/all?eventId=" + this.$route.params.id)
        .then((response) => {
          this.galleryData = response.data;
        })
        .catch((error) => {
          console.log(error.message);
        });

      //   Story Gallery
      axios
        .get("https://api.macra.co.id/mavent/story/all?eventId=" + this.$route.params.id)
        .then((response) => {
          this.storyData = response.data;
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
  };
</script>

<style scoped>
  section {
    font-family: "Poppins";
    font-size: 22px;
  }

  .invitation-nav {
    position: fixed;
    top: 90vh;
    border-radius: 500px;
    width: calc(100% - 36px);
    max-width: calc((100vw) - 36px);
    padding: 24px 10px;
    height: 56px;
    float: inline-start;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    background: rgba(255, 255, 255, 0.75);
    border-radius: 34px;
  }

  .vibe {
    font-family: "Great Vibes";
  }

  .galleryPhoto {
    width: 120px;
    height: 200px;
    padding: 12px;
    margin: 5px;
    background-color: white;
    object-fit: cover;
    border-radius: 6px;
    box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.05);
  }

  #countdown > ul > li {
    text-align: center;
    display: inline-block;
    padding: 12px 0px;
    margin: 2px 3px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 55px;
    line-height: 32px;
  }

  li > span {
    padding: 0;
    margin: 0;
  }

  #brideintro {
    position: relative;
    top: 450px;
    left: -250px;
  }

  #groomintro {
    text-align: center;
    position: relative;
    width: 20vw;
    top: 250px;
    left: 230px;
  }
  .story.bride {
    position: relative;
  }

  .story.bride > img {
    position: relative;
    width: 130px;
    height: 200px;
    padding: 10px;
    background-color: white;
    border-radius: 3px;
    object-fit: cover;
    left: 80px;
    top: 200px;
  }

  .story.groom > img {
    position: relative;
    width: 130px;
    height: 200px;
    padding: 10px;
    background-color: white;
    border-radius: 3px;
    object-fit: cover;
    right: 75px;
    top: 0px;
  }

  .storydesc {
    font-size: 12px;
  }

  #countdown > ul {
    width: 105%;
    position: relative;
    left: -20px;
    font-size: 12px;
  }

  .spacer-left {
    visibility: hidden;
  }

  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 220px;
    width: 300px;
  }
  .spacer-right {
    visibility: hidden;
  }

  #welcome > img {
    height: 100vh;
    width: 100%;
    object-fit: cover;
    object-position: bottom;
    filter: brightness(0.8);
    z-index: -1;
  }

  #about {
    min-height: 720px;
    height: 100vh;
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -1;
  }

  .storycard {
    background: url("/Event.svg");
    min-height: 720px;
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: -1;
  }

  #story {
    background-color: white;
    height: 2100px;
    width: 100%;
  }

  #gallery {
    background-image: linear-gradient(#ffffff, #eeeeee);
    height: 1300px;
    width: 100%;
  }

  #event {
    background-color: #eeeeee;
    height: 1520px;
    width: 100%;
  }

  #story > #decorevent {
    height: 720px;
    width: 100%;
    object-fit: cover;
    object-position: bottom;
    z-index: -1;
  }

  .storythumb {
    position: relative;
    left: 40px;
    padding: 5px;
    width: 250px;
    height: 180px;
    object-fit: cover;
    background-color: #ffffff;
    border-radius: 2px;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.25);
  }

  #more {
    background-color: #eeeeee;
    height: 2790px;
    width: 100%;
  }

  #decor1 {
    position: relative;
    background-color: white;
    bottom: 0;
    right: -90px;
    top: 520px;
    width: 80px;
    z-index: 99;
    border-radius: 50%;
    padding: 10px;
    float: right;
  }

  #decor2 {
    position: relative;
    bottom: 0;
    top: 45px;
    width: 140px;
    z-index: 99;
    float: right;
  }

  #decor3 {
    position: relative;
    transform: rotateY(180deg);
    bottom: 0;
    left: 0px;
    top: 120px;
    width: 140px;
    z-index: 99;
    float: left;
  }
  /* CARD */

  .card-group {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  textarea:first-of-type {
    border: none;
    border-radius: 10px;
    width: 90%;
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.05);
  }

  textarea:first-of-type:focus {
    border: solid 1px grey;
  }
  .card {
    position: relative;
    height: 220px;
    width: 350px;
    border-radius: 25px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(30px);
    border: 2px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 80px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  .logo img,
  .chip img,
  .number,
  .name,
  .from,
  .to,
  .ring {
    position: absolute; /* All items inside card should have absolute position */
  }

  .logo img {
    top: 35px;
    right: 40px;
    width: 50px;
    height: auto;
    opacity: 0.8;
  }

  .chip img {
    top: 70px;
    left: 40px;
    width: 50px;
    height: auto;
    opacity: 0.8;
  }

  .bg-bni {
    background-color: bisque;
  }
  .bg-bca {
    background-color: steelblue;
  }
  .bg-jago {
    background-color: #fdaf27;
  }

  .bg-bri {
    background-color: #161b87;
  }

  .number,
  .name,
  .from,
  .to {
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;
    letter-spacing: 2px;
    /* text-shadow: 0 0 2px rgba(0, 0, 0, 1); */
  }

  .number {
    left: 40px;
    bottom: 65px;
    font-weight: 600;
    font-family: "Nunito", sans-serif;
  }

  .name {
    font-size: 0.9rem;
    left: 40px;
    bottom: 35px;
  }

  .from {
    font-size: 0.8rem;
    bottom: 35px;
    right: 110px;
  }

  .to {
    font-size: 0.8rem;
    bottom: 35px;
    right: 40px;
  }

  /* The two rings on the card background */
  .ring {
    height: 500px;
    width: 500px;
    border-radius: 50%;
    background: transparent;
    border: 50px solid rgba(255, 255, 255, 0.1);
    bottom: -250px;
    right: -250px;
    box-sizing: border-box;
  }

  .ring::after {
    content: "";
    position: absolute;
    height: 600px;
    width: 600px;
    border-radius: 50%;
    background: transparent;
    border: 30px solid rgba(255, 255, 255, 0.1);
    bottom: -80px;
    right: -110px;
    box-sizing: border-box;
  }
  * {
    border: 1px solid rgba(0, 0, 0, 0);
  }
  html {
    font-size: 16px;
    overflow-x: hidden;
  }

  body {
    overflow-x: hidden;
    width: 100%;
  }

  .venue {
    font-size: 12px;
    width: 100%;
  }

  /* Medium screen devices (768px and above) */
  @media only screen and (min-width: 768px) {
    html {
      font-size: 18px;
    }
    .venue {
      font-size: 14px;
      width: 100%;
    }
    .invitation-nav {
      position: fixed;
      top: 90vh;
      border-radius: 500px;
      width: calc(100% - 36px);
      max-width: calc((100vw / 3) - 36px);
      padding: 24px 10px;
      height: 56px;
      float: inline-start;

      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      background: rgba(255, 255, 255, 0.75);
      border-radius: 34px;
    }

    .galleryPhoto {
      width: 200px;
      height: 200px;
      padding: 12px;
      margin: 5px;
      background-color: white;
      object-fit: cover;
      border-radius: 6px;
      box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.05);
    }

    .storythumb {
      position: relative;
      left: 55px;
      padding: 5px;
      width: 320px;
      height: 230px;
      object-fit: cover;
      background-color: #ffffff;
      border-radius: 2px;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.25);
    }
    .storydesc {
      font-size: 14px;
    }
    .galleryPhoto {
      width: 200px;
      height: 200px;
      padding: 12px;
      margin: 5px;
      background-color: white;
      object-fit: cover;
      border-radius: 6px;
      box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.05);
    }

    #countdown > ul > li {
      text-align: center;
      display: inline-block;
      padding: 16px 0px;
      margin: 2px 8px;
      border: solid 1px rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      width: 80px;
      line-height: 32px;
    }

    li > span {
      padding: 0;
      margin: 0;
    }

    #brideintro {
      position: relative;
      top: 450px;
      left: -250px;
    }

    #groomintro {
      text-align: center;
      position: relative;
      top: 250px;
      left: 230px;
    }
    .story.bride {
      position: relative;
    }

    .story.bride > img {
      position: relative;
      width: 130px;
      height: 200px;
      padding: 10px;
      background-color: white;
      border-radius: 3px;
      object-fit: cover;
      left: 80px;
      top: 200px;
    }

    .story.groom > img {
      position: relative;
      width: 130px;
      height: 200px;
      padding: 10px;
      background-color: white;
      border-radius: 3px;
      object-fit: cover;
      right: 75px;
      top: 0px;
    }

    #countdown > ul {
      width: 105%;
      position: relative;
      left: -20px;
    }

    .spacer-left {
      visibility: hidden;
    }

    .gmap_canvas {
      overflow: hidden;
      background: none !important;
      height: 220px;
      width: 380px;
    }
    .spacer-right {
      visibility: hidden;
    }

    #welcome > img {
      height: 100vh;
      width: 100%;
      object-fit: cover;
      object-position: bottom;
      filter: brightness(0.8);
      z-index: -1;
    }

    #about {
      min-height: 720px;
      height: 100vh;
      width: 100%;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      z-index: -1;
    }

    .storycard {
      background: url("/Event.svg");
      min-height: 720px;
      width: 100%;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      z-index: -1;
    }

    #story {
      background-color: white;
      height: 2100px;
      width: 100%;
    }

    #gallery {
      background-image: linear-gradient(#ffffff, #eeeeee);
      height: 1300px;
      width: 100%;
    }

    #event {
      background-color: #eeeeee;
      height: 1520px;
      width: 100%;
    }

    #story > #decorevent {
      height: 720px;
      width: 100%;
      object-fit: cover;
      object-position: bottom;
      z-index: -1;
    }

    #more {
      background-color: #eeeeee;
      height: 2790px;
      width: 100%;
    }

    #decor1 {
      position: relative;
      background-color: white;
      bottom: 0;
      right: -90px;
      top: 520px;
      width: 80px;
      z-index: 99;
      border-radius: 50%;
      padding: 10px;
      float: right;
    }

    #decor2 {
      position: relative;
      bottom: 0;
      top: 45px;
      width: 140px;
      z-index: 99;
      float: right;
    }

    #decor3 {
      position: relative;
      transform: rotateY(180deg);
      bottom: 0;
      left: 0px;
      top: 120px;
      width: 140px;
      z-index: 99;
      float: left;
    }
    /* CARD */

    .card-group {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    textarea:first-of-type {
      border: none;
      border-radius: 10px;
      width: 90%;
      padding: 15px;
      background-color: rgba(0, 0, 0, 0.05);
    }

    textarea:first-of-type:focus {
      border: solid 1px grey;
    }
    .card {
      position: relative;
      height: 270px;
      width: 450px;
      border-radius: 25px;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(30px);
      border: 2px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 0 80px rgba(0, 0, 0, 0.2);
      overflow: hidden;
    }

    .logo img,
    .chip img,
    .number,
    .name,
    .from,
    .to,
    .ring {
      position: absolute; /* All items inside card should have absolute position */
    }

    .logo img {
      top: 35px;
      right: 40px;
      width: 80px;
      height: auto;
      opacity: 0.8;
    }

    .chip img {
      top: 120px;
      left: 40px;
      width: 50px;
      height: auto;
      opacity: 0.8;
    }

    .bg-bni {
      background-color: bisque;
    }
    .bg-bca {
      background-color: steelblue;
    }
    .bg-jago {
      background-color: #fdaf27;
    }

    .bg-bri {
      background-color: #161b87;
    }

    .number,
    .name,
    .from,
    .to {
      color: rgba(0, 0, 0, 0.8);
      font-weight: 400;
      letter-spacing: 2px;
      /* text-shadow: 0 0 2px rgba(0, 0, 0, 1); */
    }

    .number {
      left: 40px;
      bottom: 65px;
      font-weight: 600;
      font-family: "Nunito", sans-serif;
    }

    .name {
      font-size: 0.9rem;
      left: 40px;
      bottom: 35px;
    }

    .from {
      font-size: 0.8rem;
      bottom: 35px;
      right: 110px;
    }

    .to {
      font-size: 0.8rem;
      bottom: 35px;
      right: 40px;
    }

    /* The two rings on the card background */
    .ring {
      height: 500px;
      width: 500px;
      border-radius: 50%;
      background: transparent;
      border: 50px solid rgba(255, 255, 255, 0.1);
      bottom: -250px;
      right: -250px;
      box-sizing: border-box;
    }

    .ring::after {
      content: "";
      position: absolute;
      height: 600px;
      width: 600px;
      border-radius: 50%;
      background: transparent;
      border: 30px solid rgba(255, 255, 255, 0.1);
      bottom: -80px;
      right: -110px;
      box-sizing: border-box;
    }
  }

  #comments::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  #comments::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5;
  }

  #comments::-webkit-scrollbar-thumb {
    background-color: #bbbbbb;
    border: none;
    border-radius: 10px;
  }

  /* Note: backdrop-filter has minimal browser support */

  select > option {
    height: 55px;
  }
</style>
